export const SET_STORM_DATA = 'SET_STORM_DATA';

export const setStormData = (stormData: any) => {
  return {
    type: SET_STORM_DATA,
    payload: stormData,
  };
};
